import * as React from 'react'
import { connect } from 'react-redux'
import Button from '@doordash/component-button'
import { Text } from '@doordash/design-language'
import { Modal } from '@doordash/component-modal'
import { SafetyCourseConfirmationImage } from './images'
import { ImageContainer, ModalContentPadding } from './styles'
import { safetyCourse as t } from './strings'
import { detectWebviewOs } from '../../../utilities/userAgent'
import { OsTypes } from '../../../webview/types'
import { ANDROID_CLOSE_DEEPLINK, IOS_CLOSE_DEEPLINK } from '../../../constants'
import * as DA from '../../../typeModules/events'
import * as events from '../../../events'

const os = detectWebviewOs()
const isWebview = detectWebviewOs() !== OsTypes.NONE

type ConfirmationSplashProps = {
  track?: (
    actions: DA.EventActions,
    name: DA.SafetyCourseSections
  ) => Promise<any>
}

const ConfirmationSplash: React.FC<ConfirmationSplashProps> = ({ track }) => {
  React.useEffect(() => {
    track(DA.EventActions.Rendered, DA.SafetyCourseSections.ConfirmationSplash)
  }, [track])

  return (
    <Modal
      isFullScreenOnMobile
      hasCloseButton={false}
      headerImage={false}
      title={t.sections.confirmation.title()}
      renderContentHeader={({ title }) => (
        <React.Fragment>
          <ImageContainer>
            <SafetyCourseConfirmationImage />
          </ImageContainer>
          <ModalContentPadding>
            <Text styles={Text.Styles.Bold22}>{title}</Text>
          </ModalContentPadding>
        </React.Fragment>
      )}
      renderFooterContent={() =>
        isWebview && (
          <Button
            onClick={() => {
              track(
                DA.EventActions.Close,
                DA.SafetyCourseSections.ConfirmationSplash
              )
              return window.location.assign(
                os === OsTypes.iOS ? IOS_CLOSE_DEEPLINK : ANDROID_CLOSE_DEEPLINK
              )
            }}
          >
            {t.sections.confirmation.button()}
          </Button>
        )
      }
      shouldRenderStickyHeader={false}
    >
      <Text styles={Text.Styles.Medium16}>
        {t.sections.confirmation.description()}
      </Text>
    </Modal>
  )
}

const mapDispatchToProps = {
  track: events.trackSafetyCourse,
}
export default connect(null, mapDispatchToProps)(ConfirmationSplash)
